module.exports = __webpack_public_path__ + "media/how_to_play.771b0c07.mp4";